import { Button, makeStyles, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as HttpErrorIllustration } from '../../../../assets/illustrations/globaleris-error-http.svg';
import { styles } from './globalError.styles';

export interface GlobalErrorProps {
  email?: string;
  onRefresh?: () => void;
  onReportError?: () => void;
  onLogout?: () => void;
}

export const GlobalError: React.FC<GlobalErrorProps> = props => {
  const [t] = useTranslation(['httpErrors']);
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorCode}>
        <HttpErrorIllustration className={classes.errorImage} aria-label={t('httpErrors:global.title')} />
      </div>
      <div className={classes.errorDescription}>
        <h1>{t('httpErrors:global.title')}</h1>
        <p>
          {t('httpErrors:global.subtitle')}
          <br />
          {t('httpErrors:global.text')}
        </p>
        <p>{t('httpErrors:global.userInfo', { email: props.email })}</p>
        {props.onRefresh && (
          <Button
            className={classes.actionButton}
            variant="contained"
            color="primary"
            onClick={() => {
              props.onRefresh && props.onRefresh();
            }}
          >
            {t('httpErrors:global.actions.refresh')}
          </Button>
        )}
        {props.onReportError && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onReportError && props.onReportError();
            }}
          >
            {t('httpErrors:global.actions.report')}
          </Button>
        )}
        {props.onLogout && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onLogout && props.onLogout();
            }}
          >
            {t('httpErrors:global.actions.logout')}
          </Button>
        )}
      </div>
    </div>
  );
};
